var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg557Birthdaycake1100853(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#45413c;opacity:0.15;}.cls-2{fill:#bf8256;}.cls-2,.cls-3,.cls-6,.cls-8,.cls-9{stroke:#45413c;}.cls-2,.cls-3,.cls-6,.cls-7,.cls-8,.cls-9{stroke-linecap:round;stroke-linejoin:round;}.cls-3{fill:#ffe3cf;}.cls-4{fill:#ff6242;}.cls-5{fill:#ff866e;}.cls-6,.cls-7{fill:none;}.cls-7{stroke:#e04122;}.cls-8{fill:#fffef2;}.cls-9{fill:#ffe500;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "557-birthday-cake-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "_Ellipse_",
    "data-name": "<Ellipse>",
    className: "cls-1",
    cx: 24,
    cy: 45.5,
    rx: 17.5,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "_Group_2",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_",
    "data-name": "<Path>",
    className: "cls-2",
    d: "M6.5,24c0,3.59,7.84,6.5,17.5,6.5S41.5,27.59,41.5,24V39c0,3.59-7.84,6.5-17.5,6.5S6.5,42.59,6.5,39Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_2",
    "data-name": "<Path>",
    className: "cls-3",
    d: "M6.5,30c0,3.59,7.84,6.5,17.5,6.5S41.5,33.59,41.5,30v5c0,3.59-7.84,6.5-17.5,6.5S6.5,38.59,6.5,35Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_Group_3",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_3",
    "data-name": "<Path>",
    className: "cls-4",
    d: "M30.5,33.5a.5.5,0,0,1,1,0,2.5,2.5,0,0,0,5,0v-2a1.5,1.5,0,0,1,3,0,1.5,1.5,0,0,0,3,0V24c0-3.59-8.28-6.5-18.5-6.5S5.5,20.41,5.5,24v8a1.5,1.5,0,0,0,3,0,1.5,1.5,0,0,1,3,0v3a2.5,2.5,0,0,0,5,0,1.5,1.5,0,0,1,3,0v1a1.5,1.5,0,0,0,3,0v-.5a2.5,2.5,0,0,1,5,0V37a1.5,1.5,0,0,0,3,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_Group_4",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_4",
    "data-name": "<Path>",
    className: "cls-5",
    d: "M24,20c7.41,0,14,1,18.08,2.63C40.29,19.7,32.88,17.5,24,17.5S7.71,19.7,5.92,22.63C10,21,16.59,20,24,20Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "_Path_5",
    "data-name": "<Path>",
    className: "cls-6",
    d: "M30.5,33.5a.5.5,0,0,1,1,0,2.5,2.5,0,0,0,5,0v-2a1.5,1.5,0,0,1,3,0,1.5,1.5,0,0,0,3,0V24c0-3.59-8.28-6.5-18.5-6.5S5.5,20.41,5.5,24v8a1.5,1.5,0,0,0,3,0,1.5,1.5,0,0,1,3,0v3a2.5,2.5,0,0,0,5,0,1.5,1.5,0,0,1,3,0v1a1.5,1.5,0,0,0,3,0v-.5a2.5,2.5,0,0,1,5,0V37a1.5,1.5,0,0,0,3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_6",
    "data-name": "<Path>",
    className: "cls-7",
    d: "M40.5,24c0,2.49-7.39,4.5-16.5,4.5S7.5,26.49,7.5,24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_5",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_7",
    "data-name": "<Path>",
    className: "cls-8",
    d: "M19.5,25.5v-8a1,1,0,0,0-1-1h-2a1,1,0,0,0-1,1v8a2.17,2.17,0,0,0,2,1A2.17,2.17,0,0,0,19.5,25.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_8",
    "data-name": "<Path>",
    className: "cls-9",
    d: "M15.2,11.55a2.37,2.37,0,0,0,4.62,1.1c.41-1.73-2.23-2-2.17-4.58A5,5,0,0,0,15.2,11.55Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_6",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_9",
    "data-name": "<Path>",
    className: "cls-8",
    d: "M13.5,22.5v-8a1,1,0,0,0-1-1h-2a1,1,0,0,0-1,1v8a2.17,2.17,0,0,0,2,1A2.17,2.17,0,0,0,13.5,22.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_10",
    "data-name": "<Path>",
    className: "cls-9",
    d: "M9.2,8.55a2.37,2.37,0,0,0,4.62,1.1c.41-1.73-2.23-2-2.17-4.58A5,5,0,0,0,9.2,8.55Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_7",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_11",
    "data-name": "<Path>",
    className: "cls-8",
    d: "M38.5,22.5v-8a1,1,0,0,0-1-1h-2a1,1,0,0,0-1,1v8a2.5,2.5,0,0,0,4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_12",
    "data-name": "<Path>",
    className: "cls-9",
    d: "M34.2,8.55a2.37,2.37,0,1,0,4.62,1.1c.41-1.73-2.23-2-2.17-4.58A5,5,0,0,0,34.2,8.55Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_8",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_13",
    "data-name": "<Path>",
    className: "cls-8",
    d: "M32.5,25.5v-8a1,1,0,0,0-1-1h-2a1,1,0,0,0-1,1v8a2.17,2.17,0,0,0,2,1A2.17,2.17,0,0,0,32.5,25.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_14",
    "data-name": "<Path>",
    className: "cls-9",
    d: "M28.2,11.55a2.37,2.37,0,0,0,4.62,1.1c.41-1.73-2.23-2-2.17-4.58A5,5,0,0,0,28.2,11.55Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_9",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_15",
    "data-name": "<Path>",
    className: "cls-8",
    d: "M26,19.5v-8a1,1,0,0,0-1-1H23a1,1,0,0,0-1,1v8a2.17,2.17,0,0,0,2,1A2.17,2.17,0,0,0,26,19.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_16",
    "data-name": "<Path>",
    className: "cls-9",
    d: "M21.7,5.55a2.37,2.37,0,0,0,4.62,1.1c.41-1.73-2.23-2-2.17-4.58A5,5,0,0,0,21.7,5.55Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg557Birthdaycake1100853);
export default __webpack_public_path__ + "static/media/557birthdaycake1_100853.6711ce1ecdc77cfbd572a5e3311ce620.svg";
export { ForwardRef as ReactComponent };